<template>

  <draggable class="dragArea list-group w-full" :list="list" @change="log">

    <li v-for="item in list" :key="item?.id" class="w-full flex flex-col" :data-id="`nested-${item.id}`">

      <button :id="`dropdown-pages-button-${item.id}`" type="button" :aria-controls="`dropdown-pages${item.id}`"
        :data-collapse-toggle2="`dropdown-pages${item.id}`"
        class="relative h-6 group flex flew-row items-start pr-3 w-full hover:bg-gray-100   font-normal text-gray-900 rounded-lg transition duration-75  max-w-96   truncate "
        :class="{ 'bg-gray-200': item.id == selected?.id }" @click="onSelectSection(item)">
        <div class="mr-1 opacity-0 "
          :class="{ 'opacity-0': (item.type != 'list') && (item.type != 'row'), 'opacity-100': (item.type == 'list') || (item.type == 'row') }">
          <i class="fa-xs opacity:0 text-gray-600 fa-solid  hover:rotate-90 shrink-0  fa-chevron-down   " />
        </div>
        <div class="flex-1 ml-1 text-left text-sm flex flex-row items-center">
          <div class="mr-1.5 w-4  flex flex-row items-center">
            <i class="fa-solid  group-hover:flex hidden text-gray-800 fa-xs     fa-braille " />
            <i class="fa-solid   group-hover:hidden flex text-gray-800 fa-xs  fa-vector-square  " />
          </div>
          <span class=" text-left whitespace-nowrap font-normal text-gray-500 opacity-100 pr-5 w-56 truncate"
            :class="{ 'font-bold': (selected?.id == item.id) }">{{
              item.type }} - <span class="truncate max-w-24  italic">{{ item.title }} </span>
            ({{ item?.components?.length }})
          </span>
        </div>


        <div class="absolute right-1">
          <i class="group-hover:opacity-100 opacity-0 text-gray-500 fa-solid   shrink-0   fa-trash  fa-xs ml-2 "
            @click="onDelete($event, item)" />

          <i class="group-hover:opacity-100 opacity-0  text-gray-500 fa-solid   shrink-0 fa-xs ml-2 mr-2    "
            :class="{ 'fa-eye': (item.isVisible || (item.isVisible == undefined)), 'fa-eye-slash': (!item.isVisible) }"
            @click="showHideItem(item)" />
        </div>
      </button>

      <ul v-if="(item.type == 'list') || (item.type == 'row')" :id="`dropdown-pages${item.id}`"
        class="hidden   space-y-2 pl-6">
        <NestedElement class="  dragArea list-group w-full" :list="item.components" :item="item" @reload="load"
          @add-sub-section="onAddSubSection" @select="OnSelectItem" @delete="onDeleteItem"
          @move-section="onMoveSubSection" />



        <li class="  pl-2">
          <button :id="`dropdownRightEndButtonBodySubItem${item?.id}`" type="button"
            class="flex flew-row items-center px-2 w-full hover:bg-gray-200  py-1 font-normal text-gray-900 rounded-lg transition duration-75      "
            @click="openDropdownRightEndButtonBodySubItem(item.id)">
            <div class="  mr-1">
              <i class="fa-xs text-blue-600 fa-solid  hover:rotate-90 shrink-0  fa-plus   " />
            </div>
            <div class="flex-1 ml-1 text-left text-sm">
              <span class=" text-left whitespace-nowrap font-normal  text-blue-600">
                Ajouter une sous section
              </span>
            </div>
          </button>
          <!-- Dropdown menu -->
          <div :id="`dropdownRightEndBodySubItem${item?.id}`"
            class="z-10 hidden bg-red-200 divide-y divide-gray-100 rounded-lg shadow   min-w-96 min-h-96">
            <popupAddSection class=" " :parent="item" zone="body" @select="onSelectComponentBodySubItem" />
          </div>
        </li>
      </ul>


      <button :id="`dropdownRightEndButtonBodyItem${item.id}`" type="button" data-dropdown-placement="right-start"
        class="group  relative   cursor-pointer  w-full   h-2  " @click="openDropdownRightEndButtonBodyItem(item.id)">
        <div class="  absolute top-0 bottom-0 flex    items-center w-full ease-in-out  delay-75 ">
          <div
            class="transition ease-in-out duration-1000 group-hover:opacity-100 opacity-0  h-0.5 w-full bg-blue-600  w-6 group-hover:w-full "
            :class="{ 'opacity-100 w-full': selecteAddSectionButton == item.id }" />
        </div>
        <div
          class="group-hover:opacity-100 opacity-0 absolute top-0 bottom-0 left-0 right-0 justify-center flex items-center transition ease-in-out delay-75"
          :class="{ 'opacity-100': selecteAddSectionButton == item.id }">
          <i class="   bg-white  fa-solid fa-lg  text-blue-600  fa-circle-plus   " />
        </div>
      </button>
      <!-- Dropdown menu -->
      <div :id="`dropdownRightEndBodyItem${item.id}`"
        class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow  ">
        <popupAddSection zone="body" :properties="item" @select="onSelectComponentBodyItem" />
      </div>
    </li>
  </draggable>
</template>
<script>

import popupAddSection from '@/layout/Editor/Popups/popupAddSection.vue'
import { VueDraggableNext } from 'vue-draggable-next'
import { Dropdown, Collapse /*,  Drawer*/ } from 'flowbite';
export default {
  name: "NestedElement",
  components: {
    draggable: VueDraggableNext, popupAddSection
  },
  props: {
    list: Array,
    components: Array,
    item: Object,
    selected: Object
  },
  data() {
    return {
      selecteAddSectionButton: null,
      dropdownAddSection: {},
      dropdownAddSubSection: {},
    }
  },
  watch: {

    'selected': function () {
      console.log("///WATCH selected----------Nested")
      const targetElement = document.querySelector(`[data-id="nested-${this.selected.id}"]`);
      if (targetElement) {
        console.log("targetElement----------")

        const parentDiv = document.querySelector('#sidenav-item-list'); //targetElement.closest('.overflow-y-scroll'); // Trouver le conteneur défilable

        // S'assurer que les éléments existent
        if (parentDiv) {
          ///  console.log("parentDiv----------")




          const elementTop = targetElement.offsetTop;
          const elementBottom = elementTop + targetElement.offsetHeight;
          const parentScrollTop = parentDiv.scrollTop;
          const parentHeight = parentDiv.offsetHeight;

          // Si l'élément est en dehors de la vue, ajuster la position
          if (elementTop < parentScrollTop || elementBottom > parentScrollTop + parentHeight) {




            const headerElement = document.querySelector('#sidenav-sub-header');
            // const headerElement = document.querySelector('#sidenav-item-list > div:first-child').offsetHeight;


            if (headerElement) {
              //  console.log("headerElement----------")
              let headerHeight = headerElement.offsetHeight + 100;

              if (headerHeight == undefined) headerHeight = 145
              // Obtenir la position actuelle de l'élément et ajuster en fonction du header
              const targetPosition = targetElement.offsetTop - headerHeight;


              //     console.log("headerElement.offsetHeight =", headerElement.offsetHeight)

              //    console.log("headerHeight =", headerHeight)
              //     console.log("targetElement.offsetTop =", targetElement.offsetTop)
              //     console.log("targetPosition =", targetPosition)
              // Faire défiler jusqu'à l'élément
              parentDiv.scrollTo({
                top: targetPosition,
                behavior: 'smooth', // Défilement fluide
                //  block: 'nearest',   // Positionner l'élément visible dans le viewport
              });
            }
            else {
              //  console.log("headerElement is null")
            }
          } else {
            // console.log("is visible") 
          }

        } else {
          // console.log("parentDiv is null") 
        }
      }
      else {
        //  console.log("targetElement is null") 
      }
    },
  },
  methods: {
    onAddSubSection: function () {

    },
    load: function () {

    },
    openDropdownRightEndButtonBodyItem: function (id) {



      if (this.dropdownAddSection[id] == undefined) {


        const options = {
          triggerType: 'none',
          placement: 'right-start',
          onHide: () => {

          },
          onShow: () => {

          },
          onToggle: () => {

          },
        }

        const $targetElBody = document.getElementById('dropdownRightEndBodyItem' + id);
        const $triggerElBody = document.getElementById('dropdownRightEndButtonBodyItem' + id);


        let dropdownBody = new Dropdown($targetElBody, $triggerElBody, options);
        this.dropdownAddSection[id] = dropdownBody
        this.dropdownAddSection[id].toggle();
      }
      else {
       
        this.dropdownAddSection[id].toggle();
      }
      this.selecteAddSectionButton = id

    },

    OnSelectItem: function (/*item*/) {


    },
    onSelectSection: function (item) {

      const options = {
        triggerType: 'none',

     //   onCollapse: () => {
     //     console.log('onSelectSectionelement has been collapsed');
     //   },
    //    onExpand: () => {
    //      console.log('onSelectSection element has been expanded');
    //    },
    //    onToggle: () => {
    //      console.log('onSelectSection  dropdown has been toggled');
    //    },
      }

      if ((item.type == 'list') || (item.type == 'row'))
        if (this.dropdownAddSection[item.id] == undefined) {
          const $targetElBody = document.getElementById("dropdown-pages" + item.id);
          const $triggerElBody = document.getElementById("dropdown-pages-button-" + item.id);

       

          const instanceOptions = {
            id: '"dropdown-pages"+item.id',
            override: true
          };

          this.dropdownAddSection[item.id] = new Collapse($targetElBody, $triggerElBody, options, instanceOptions);
          if (this.dropdownAddSection[item.id] != null) this.dropdownAddSection[item.id].expand();
        }



      // 
      this.$emit("select", item)

    },
    openDropdownRightEndButtonBodySubItem: function (id) {



      console.log("openDropdownRightEndButtonBodySubItem", id)

      if (this.dropdownAddSubSection[id] == undefined) {

        console.log("Create DropDown ", id)
        const options = {
          triggerType: 'none',
          placement: 'right-start',
          onHide: () => {
            console.log('openDropdownRightEndButtonBodySubItem  dropdown has been hidden');
          },
          onShow: () => {
            console.log('openDropdownRightEndButtonBodySubItem  dropdown has been shown');
          },
          onToggle: () => {
            console.log('openDropdownRightEndButtonBodySubItem  dropdown has been toggled');
          },
        }

        const $targetElBody = document.getElementById('dropdownRightEndBodySubItem' + id);
        const $triggerElBody = document.getElementById('dropdownRightEndButtonBodySubItem' + id);

        //   console.log(">>>>>>>>", $targetElBody)
        //  console.log(">>>>>>>>", $triggerElBody)
        let dropdownBody = new Dropdown($targetElBody, $triggerElBody, options);
        this.dropdownAddSubSection[id] = dropdownBody
        this.dropdownAddSubSection[id].toggle();
      }
      else {
        console.log("exit DropDown ", id)
        this.dropdownAddSubSection[id].show();
      }
      this.selecteAddSubSectionButton = id

    },
    onSelectComponentBodyItem: function (event) {



      //     console.log("onSelectComponentBodySubItem", event?.id, event.parent)
      //     console.log(event)
      //     console.log(this.dropdownAddSection)

      if (this.dropdownAddSection[event.id].isVisible()) this.dropdownAddSection[event.id].toggle();
      //    this.dropdownAddSection = null
      this.$emit("addSection", { zone: "body", section: event.section, parent: null, after: event.id })
      this.$emit("reload")

    },

    onSelectComponentBodySubItem: function (event) {



      //      console.log("onSelectComponentBodySubItem", event?.id, event.parent)
      //      console.log(event)
      //      console.log(this.dropdownAddSubSection)

      if (this.dropdownAddSubSection[event.parent].isVisible()) this.dropdownAddSubSection[event.parent].toggle();
      this.selecteAddSubSectionButton = null
      this.$emit("addSubSection", { zone: "body", section: event.section, parent: event.parent })
      this.$emit("reload")

    },

    onSelectSubSection: function (event, subitem, item) {



      event.stopPropagation()
      this.$emit("selectSubSection", { id: subitem.id, parent: item.id })

    },

    onDeleteItem: function (item) {
      //                event.stopPropagation()
   

      this.$emit("delete", item)
      return false
    },
    onMoveSubSection: function (subitem) {


      //   event.stopPropagation();
    
      //if (subitem.moved != undefined) {


      this.$emit("moveSubSection", subitem)
      // }

    },

    onDelete: function (event, item) {
      event.stopPropagation()

     

      this.$emit("delete", item)



      return false
    },
    log(item) {
      //   event.stopPropagation();
     
      // console.log(JSON.stringify(this.list))
      if (item.moved != undefined) {

        // this.$emit("moveSection", { zone: "body", id: item.moved.element.id, oldIndex: item.moved.oldIndex, newIndex: item.moved.newIndex })

        if (this.item != null) {
          this.$emit("moveSection", { zone: "body", id: item.moved.element.id, parent: this.item.id, oldIndex: item.moved.oldIndex, newIndex: item.moved.newIndex })

        }
        else {
          this.$emit("moveSection", { zone: "body", id: item.moved.element.id, oldIndex: item.moved.oldIndex, newIndex: item.moved.newIndex })
        }
      }

    },
  }
};

</script>